import { Component, Injector, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DialogService } from "../shared/dialog/dialog.service";
import { ButtonInvoke, PanelButtonsComponent } from "../shared/panel-buttons/panel-buttons.component";
import { DokladovaRadaTabulkaComponent } from "./dokladova-rada-tabulka/dokladova-rada-tabulka.component";

const COMPARE_COLUMNS =
  [
    { name: "kodUj", type: "autocomplete", title: "Účetní jednotka" },
    { name: "kodUo", type: "extended_autocomplete", title: "Kód účetního období" }
];

@Component({
    selector: 'cml-dokladova-rada',
    templateUrl: './dokladova-rada.component.html',
    styleUrls: ['./dokladova-rada.component.scss'],
    standalone: false
})
export class DokladovaRadaComponent implements OnInit
{

  @ViewChild(DokladovaRadaTabulkaComponent) child: DokladovaRadaTabulkaComponent | any;

  buttons: ButtonInvoke[] = [];
  kodUo: string = "";
  isEdit: boolean = false;
  isComparation: boolean = false;
  compareColumns = COMPARE_COLUMNS;
  compareKodUj: string = "";
  compareKodUo: string = "";

  constructor(private route: ActivatedRoute, private router: Router, private dialog: DialogService)
  {
    this.buttons = this.createToolbarButtons();
  }

  async ngOnInit(): Promise<void>
  {
    this.kodUo = this.route.snapshot.paramMap.get('kod')!;
  }

  createToolbarButtons(): ButtonInvoke[]
  {
    let buttons: ButtonInvoke[] = [];
    buttons.push(new ButtonInvoke(this, 'Nová dokladová řada', 'new', '<i class="cml-fw cml-lg cml-plus"></i>', 'cml-active-black'));
    buttons.push(new ButtonInvoke(this, 'Kopírovat z jiné UJ', 'copy', '<i class="cml-fw cml-lg cml-copy"></i>', 'cml-active-black'));
    buttons.push(new ButtonInvoke(this, this.isComparation ? 'Konec porovnání' : 'Porovnat', this.isComparation ? 'stopCompare' : 'compare', '<i class="cml-fw cml-lg cml-weight"></i>', 'cml-active-black'));
    buttons.push(new ButtonInvoke(this, this.isEdit ? 'Konec editování' : 'Editovat', this.isEdit ? 'stopEdit' : 'edit', '<i class="cml-fw cml-lg cml-edit-pen"></i>', this.isEdit ? 'cml-active-red' : 'cml-active-blue'));
    buttons.push(new ButtonInvoke(this, 'Uložit', 'save', '<i class="cml-fw cml-lg cml-floppy-o"></i>', 'cml-active-green'));
    buttons.push(new ButtonInvoke(this, 'Zpět', 'navigateBack', '<i class="cml-fw cml-lg cml-arrow-left"></i>', 'cml-active-black'));
    buttons.push(new ButtonInvoke(this, 'Zavřít', 'close', '<i class="cml-fw cml-lg cml-close"</i>', 'cml-active-black'))
    return this.buttons = buttons;

  }

  public invoke(method: Exclude<keyof DokladovaRadaComponent, "navigateBack" | "invoke" | "component" | "get" | "getId" | "create" | "edit" | "delete" | "init" | "createToolbarButtons" | "canDelete">)
  {
    this[method]();
  }

  navigateBack()
  {
    this.router.navigateByUrl(this.router.url.replace("/dokladova-rada/" + this.kodUo, ''));
  }

  new()
  {
    this.child.new();
  }

  edit()
  {
    this.isEdit = this.child.edit();
    this.createToolbarButtons()
  }

  stopEdit()
  {
    this.isEdit = this.child.stopEdit();
    this.createToolbarButtons()
  }

  copy()
  {
    this.child.copy();
  }

  close()
  {
    this.router.navigateByUrl(this.route.snapshot.data["basePath"]);
  }

  save()
  {
    this.child.save();
    this.isEdit = false;
    this.createToolbarButtons()
  }

  async compare()
  {
    await this.child.addObservable(this.compareColumns);
    const form = await this.dialog.form({title: "Porovnání dokladové řady", detail: this.compareColumns, validation: true, component: this.child as any});
    if (form)
    {
      const entity = this.child.fillEntityFromForm(form, this.compareColumns);
      this.compareKodUj = entity["kodUj"];
      this.compareKodUo = entity["kodUo"];
      this.isComparation = true;
      this.createToolbarButtons()
    }
  }
  stopCompare()
  {
    this.isComparation = false;
    this.createToolbarButtons()
  }

}
